import React from 'react';
import { Theme } from '../types';
import { SunIcon, MoonIcon, MonitorIcon } from 'shared-icons';

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme, onToggle }) => {
  let Icon, title;

  switch (theme) {
    case 'light':
      Icon = SunIcon;
      title = 'Switch to Dark Mode';
      break;
    case 'dark':
      Icon = MoonIcon;
      title = 'Switch to System Preference';
      break;
    case 'auto':
    default:
      Icon = MonitorIcon;
      title = 'Switch to Light Mode';
      break;
  }
  
  return (
    <button
      onClick={onToggle}
      className="p-2 rounded-full text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-gray-200 dark:hover:bg-slate-700/50 transition-colors"
      aria-label={title}
      title={title}
    >
      <Icon />
    </button>
  );
};

export default ThemeToggle;